import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CategoryService } from './api/category.service';
import { DashboardService } from './api/dashboard.service';
import { DonationService } from './api/donation.service';
import { FamilyService } from './api/family.service';
import { ListService } from './api/list.service';
import { MemberService } from './api/member.service';
import { NeedService } from './api/need.service';
import { NoteService } from './api/note.service';
import { OrganisationMemberService } from './api/organisationMember.service';
import { TokensService } from './api/tokens.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
